// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { authReady } from './components/firebase';
import './global.css';


authReady.then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
});
